import { Option, LabeledSelect } from 'components/Select';
import { rm } from 'utils';
import {
  Attribute,
  useConfigurator,
  useVisibility
} from 'views/ProductPage/configurators/useConfigurator';
import connect from 'components/Shared/connect';
import { getAttributes } from 'views/ProductPage/selector';
import { ProductAttribute } from 'models/ProductAttribute';
import { useEffect } from 'react';
import { getAttribute } from 'views/ProductPage/configurators/selector';

interface Props extends Attribute {
  attribute: ProductAttribute | undefined;
}

interface StateProps {
  attributes: ProductAttribute[][];
}
export const AttributeFilter = connect<Props, Attribute, StateProps>(
  state => ({
    attributes: getAttributes(state.currentPage)
  }),
  undefined,
  ({ attributes, variables, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    attribute: getAttribute({ attributes, id: props.id })
  })
)(function _AttributeFilter({ attribute, ...a }: Props) {
  const { onSelectChange } = useConfigurator();
  const isVisible = useVisibility();

  const options = !attribute ? a.values : a.values.filter(v => attribute.value.includes(v.value));
  const onChange = (value: string) => onSelectChange(a.id, value);

  useEffect(() => {
    if (options.length === 1 && options[0].value !== a.selected) {
      onChange(options[0].value);
    } else if (Boolean(a.selected) && !options.find(o => o.value === a.selected)) {
      onSelectChange(a.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, onChange, a.selected, a.id]);

  useEffect(() => {
    if (a.selected === undefined) {
      onSelectChange(a.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [a.selected, a.id]);

  return (
    <LabeledSelect
      label={a.name}
      isSelected={!!a.selected}
      placeHolder={rm('product_variant_choose')}
      onChange={onChange}
      selectedValue={a.selected}
      labelFormat={`{0} ${a.unit || ''}`}
      scrollable
      disabled={!isVisible(a.id)}
    >
      {options.map(value => (
        <Option key={value.value} {...value} />
      ))}
    </LabeledSelect>
  );
});
